import type { AuthContextType } from '../contexts';

type Org = NonNullable<AuthContextType['auth']>['org'];
type Feature = Org['features'][number];

export type OrgFeatureMap = Record<Feature, true | undefined>;

const getOrgFeatureMap = (org: Pick<Org, 'features'>) => {
  const orgFeatureMap = (org.features ?? []).reduce(
    (acc, feature) => ({
      ...acc,
      [feature]: true,
    }),
    {} as OrgFeatureMap,
  );
  return orgFeatureMap;
};

export default getOrgFeatureMap;
